import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonDataService } from '@app/services/common-data/common-data.service';

@Component({
  selector: 'not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPageComponent {
  protected commonDataService = inject(CommonDataService);
}
